export enum AppIcon {
  ClassroomCourse = 'classroom-course',
  OnlineCourse = 'online-course',
  RoundedUser = 'rounded-user',
  UsersGroup = 'users-group',
  CirclesQuestionMark = 'circled-question-mark',
  SuccessCheck = 'success-check',
  CaretDown = 'caret-down',
  CaretUp = 'caret-up',
  CaretRight = 'caret-right',
  CaretLeft = 'caret-left',
  Add = 'add',
  Remove = 'remove',
  Edit = 'edit',
  List = 'list',
  Calendar = 'calendar',
  Courses = 'courses',
  Download = 'download',
  Upload = 'upload',
  LoadingSpinner = 'loading-spinner',
  Exit = 'exit',
  CircledInfo = 'circled-info',
  Warning = 'warning',
  EducationHat = 'education-hat',
  Certificate = 'certificate',
  Delete = 'delete',
  Clock = 'clock',
  ClockOutline = 'clock-outline',
  CircledArrowRight = 'circled-arrow-right',
  CircledArrowLeft = 'circled-arrow-left',
  CircledArrowDown = 'circled-arrow-down',
  CircledArrowUp = 'circled-arrow-up',
  User = 'user',
  UserAdd = 'user-add',
  UserRemove = 'user-remove',
  Hamburger = 'hamburger',
  View = 'view',
  ExternalLink = 'external-link',
  CircledAlert = 'circled-alert',
  TriangledAlert = 'triangled-alert',
  Webinar = 'webinar',
  FinalReview = 'final-review',
  SatisfactionQuiz = 'satisfaction-quiz',
  Finalized = 'finalized',
  Pencil = 'perncil',
  HalfStar = 'half-star',
  OpenBookReader = 'open-book-reader',
  ArrowUp = 'arrow-up',
  ArrowDownMini = 'arrow-down-mini',
  ErrorCross = 'error-cross',
  QuestionMark = 'question-mark',
  UserCircle = 'user-circle',
  UserCircleOutline = 'user-circle-outline',
  Eye = 'eye',
  EyeOff = 'eye-off',
  CircledFileDownload = 'circled-file-download',
  Unlink = 'unlink',
  StarOutline = 'star-outline',
  StarSolid = 'star-solid',
  ListBullet = 'list-bullet',
  Plus = 'plus',
  Minus = 'minus',
  SelectAll = 'select-all',
  DeselectAll = 'deselect-all',
  Play = 'play'
}
